import {FaEye, FaPencilAlt, FaTrash} from "react-icons/fa";
import {getUrl} from "../../../constants/urls";

export const simListURL = getUrl("listSim");

export const ACTIONS_LIST = [
  {label: "View", icon: FaEye, perms: ["view_sim"]},
  {label: "Edit", icon: FaPencilAlt, perms: ["change_sim"]},
  {label: "Delete", icon: FaTrash, perms: ["delete_sim"]},
];

export const PERMS_FOR_ACTIONS = ["view_sim", "change_sim", "delete_sim"];

export const LIST_HEADERS = [
  "id",
  "carrier",
  "iccid",
  "imei",
  "ip_address",
  "status",
  "activate",
  "suspend",
  "serial",
  "organization",
];

export const SORTABLE_FIELDS = [
  {
    label: "Carrier",
    value: "carrier",
  },
  {
    label: "ICCID",
    value: "iccid",
  },
  {
    label: "IMEI",
    value: "imei",
  },
  {
    label: "IP Address",
    value: "ip_address",
  },
  {
    label: "Status",
    value: "status",
  },
  {
    label: "Activate",
    value: "activate",
  },
  {
    label: "Suspend",
    value: "suspend",
  },
  {
    label: "Serial",
    value: "serial",
  },
  {
    label: "Organization",
    value: "organization",
  },
];

const simColumns = {
  Carrier: "carrier",
  iccid: "iccid",
  imei: "imei",
};

export const getColumnValue = (label) => {
  return simColumns[`${label}`];
};
